import { MeasureCategory, type MeasureConfig, type ProcessAnalysisFilters } from './process-analysis-v2.type';

/**
 * Centralized measure configuration array
 * Contains all static properties for every measure
 */
const MEASURES_CONFIG: MeasureConfig[] = [
  // Time Metrics
  {
    id: 'lead_time',
    category: MeasureCategory.TimeMetrics,
    nameKey: 'process_analysis.measures.time_metrics.lead_time',
    isTrend: true,
    disabled: false,
  },
  {
    id: 'reaction_time',
    category: MeasureCategory.TimeMetrics,
    nameKey: 'process_analysis.measures.time_metrics.reaction_time',
    isTrend: true,
    disabled: false,
  },
  {
    id: 'cycle_time',
    category: MeasureCategory.TimeMetrics,
    nameKey: 'process_analysis.measures.time_metrics.cycle_time',
    isTrend: true,
    disabled: false,
  },
  {
    id: 'review_time',
    category: MeasureCategory.TimeMetrics,
    nameKey: 'process_analysis.measures.time_metrics.review_time',
    isTrend: true,
    disabled: false,
  },

  // Performance Metrics
  {
    id: 'throughput',
    category: MeasureCategory.PerformanceMetrics,
    nameKey: 'process_analysis.measures.performance_metrics.throughput',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'velocity',
    category: MeasureCategory.PerformanceMetrics,
    nameKey: 'process_analysis.measures.performance_metrics.velocity',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'points_acceptance_rate',
    category: MeasureCategory.PerformanceMetrics,
    nameKey: 'process_analysis.measures.performance_metrics.points_acceptance_rate',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'tasks_acceptance_rate',
    category: MeasureCategory.PerformanceMetrics,
    nameKey: 'process_analysis.measures.performance_metrics.tasks_acceptance_rate',
    isTrend: false,
    disabled: true,
  },

  // Task Process Metrics
  {
    id: 'bulk_status_changes',
    category: MeasureCategory.TaskProcessMetrics,
    nameKey: 'process_analysis.measures.task_process_metrics.bulk_status_changes',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'tasks_moving_backwards',
    category: MeasureCategory.TaskProcessMetrics,
    nameKey: 'process_analysis.measures.task_process_metrics.tasks_moving_backwards',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'stale_tasks',
    category: MeasureCategory.TaskProcessMetrics,
    nameKey: 'process_analysis.measures.task_process_metrics.stale_tasks',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'missing_days',
    category: MeasureCategory.TaskProcessMetrics,
    nameKey: 'process_analysis.measures.task_process_metrics.missing_days',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'multiple_point_changes',
    category: MeasureCategory.TaskProcessMetrics,
    nameKey: 'process_analysis.measures.task_process_metrics.multiple_point_changes',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'readiness',
    category: MeasureCategory.TaskProcessMetrics,
    nameKey: 'process_analysis.measures.task_process_metrics.readiness',
    isTrend: false,
    disabled: true,
  },

  // Quality Metrics
  {
    id: 'quality',
    category: MeasureCategory.QualityMetrics,
    nameKey: 'process_analysis.measures.quality_metrics.quality',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'declined_change_requests',
    category: MeasureCategory.QualityMetrics,
    nameKey: 'process_analysis.measures.quality_metrics.declined_change_requests',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'untested_tasks',
    category: MeasureCategory.QualityMetrics,
    nameKey: 'process_analysis.measures.quality_metrics.untested_tasks',
    isTrend: false,
    disabled: true,
  },

  // Consistency Metrics
  {
    id: 'cycle_time_inconsistency',
    category: MeasureCategory.ConsistencyMetrics,
    nameKey: 'process_analysis.measures.consistency_metrics.cycle_time_inconsistency',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'work_plan_inconsistency',
    category: MeasureCategory.ConsistencyMetrics,
    nameKey: 'process_analysis.measures.consistency_metrics.work_plan_inconsistency',
    isTrend: false,
    disabled: true,
  },

  // Complexity Strategy
  {
    id: 'complexity',
    category: MeasureCategory.ComplexityStrategy,
    nameKey: 'process_analysis.measures.complexity_strategy.complexity',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'strategy',
    category: MeasureCategory.ComplexityStrategy,
    nameKey: 'process_analysis.measures.complexity_strategy.strategy',
    isTrend: false,
    disabled: true,
  },

  // Dependency Independence
  {
    id: 'independence_technical_debt',
    category: MeasureCategory.DependencyIndependence,
    nameKey: 'process_analysis.measures.dependency_independence.independence_technical_debt',
    isTrend: false,
    disabled: true,
  },
  {
    id: 'technical_debt_tasks',
    category: MeasureCategory.DependencyIndependence,
    nameKey: 'process_analysis.measures.dependency_independence.technical_debt_tasks',
    isTrend: false,
    disabled: true,
  },
];

/**
 * Maps filter category keys to their corresponding filter arrays
 */
const CATEGORY_TO_FILTER_KEY_MAP: Record<MeasureCategory, keyof ProcessAnalysisFilters> = {
  [MeasureCategory.TimeMetrics]: 'timeMetrics',
  [MeasureCategory.PerformanceMetrics]: 'performanceMetrics',
  [MeasureCategory.TaskProcessMetrics]: 'taskProcessMetrics',
  [MeasureCategory.QualityMetrics]: 'qualityMetrics',
  [MeasureCategory.ConsistencyMetrics]: 'consistencyMetrics',
  [MeasureCategory.ComplexityStrategy]: 'complexityStrategy',
  [MeasureCategory.DependencyIndependence]: 'dependencyIndependence',
};

export { CATEGORY_TO_FILTER_KEY_MAP, MEASURES_CONFIG };
